import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import MonitorIcon from '@mui/icons-material/Monitor';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined';
import { useEffect, useState } from 'react';
// @mui
import {
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    CircularProgress,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    Divider,
    Fade,
    Grid,
    Grow,
    LinearProgress,
    Paper,
    Stack,
    Table,
    TableBody,
    TableContainer,
    TablePagination,
    TextField,
    Tooltip,
    Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Iconify from '../../../components/iconify';
import Scrollbar from '../../../components/scrollbar';
import call from '../../../core/services/http';
// sections
import { TableNoData, UserTableHead, UserTableRow } from '../../../sections/@dashboard/user';

import { Page, TableSkeleton } from '../../../components';
import { getComparator } from '../../../hooks/useTable';
import { applyFilter } from '../../../sections/@dashboard/user/utils';
import { fSize } from '../../../utils/formatFileSize';
import { fNumber } from '../../../utils/formatNumber';
import { AssetFilter, NewTransfer } from '../components';
import { filterAssets, getAssets, uploadAssets } from '../store/assetActions';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// const storedUser = JSON.parse(localStorage.getItem('profile'));
// const branchRoles = ['MANAGER', 'ASST_MANAGER'];

// const isManager = storedUser?.role && branchRoles.includes(storedUser.role);

const toastrSuccess = (msg) => {
  toast.success(msg);
};

export default function FixedAssets() {
  const dispatch = useDispatch();
  const { isLoading, isUploading, fixedAssets, count } = useSelector((state) => state.assetReducer);
  //

  // const defaultValues = {
  //   uploadedFile: null,
  // };

  const [page, setPage] = useState(0);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [openTransfer, setOpeTransfer] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [order, setOrder] = useState('asc');
  const [filterName, setFilterName] = useState('');
  const [activeFilters, setActiveFilters] = useState(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSort = (event, id) => {
    const isAsc = orderBy === id && order === 'asc';
    if (id !== '') {
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(id);
    }
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = fixedAssets?.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  const handleSelectClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected?.slice(1));
    } else if (selectedIndex === selected?.length - 1) {
      newSelected = newSelected.concat(selected?.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected?.slice(0, selectedIndex), selected?.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };
  const dataFiltered = applyFilter({
    inputData: fixedAssets,
    comparator: getComparator(order, orderBy),
    filterName,
  });

  const handleFileUpload = async () => {
    if (uploadedFile) {
      const formData = new FormData();
      formData.append('assets_file', uploadedFile);
      dispatch(uploadAssets(formData));
      setOpen(false);
      setUploadedFile(null);
    }
  };

  const handleApplyFilter = (filters) => {
    setActiveFilters(filters);
    setPage(0);
  };

  const handleClearFilter = () => {
    setActiveFilters(null);
    setPage(0);
  };

  const handleCloseFilter = () => {
    setOpenFilter(!openFilter);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleTransfer = () => {
    setOpeTransfer(false);
    setSelected([]);
    setTimeout(() => {
      if (activeFilters) {
        dispatch(filterAssets({ ...activeFilters, page: page + 1, rowsPerPage }));
      } else {
        dispatch(getAssets({ page: page + 1, rowsPerPage }));
      }
    }, 1000);
  };

  const fetchData = async (dispatch, page, rowsPerPage, filters) => {
    try {
      if (filters) {
        await dispatch(filterAssets({ ...filters, page: page + 1, rowsPerPage }));
      } else {
        await dispatch(getAssets({ page: page + 1, rowsPerPage }));
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const syncERPData = () => {
    try {
      call('post', 'assets/sync/');
      toastrSuccess('Assets sync initiated');
    } catch (error) {
      // Handle errors
      console.error('Error initiating sync:', error);
    }
  };

  useEffect(() => {
    fetchData(dispatch, page, rowsPerPage, activeFilters);
  }, [dispatch, page, rowsPerPage, activeFilters]);

  const denseHeight = 72;
  const isNotFound = !dataFiltered?.length && !!filterName;
  // (!dataFiltered.length && !!filterRole) ||
  // (!dataFiltered.length && !!filterStatus);

  return (
    <>
      <Page title="Assets">
        {openFilter && (
          <AssetFilter
            open={openFilter}
            handleClose={handleCloseFilter}
            onApplyFilter={handleApplyFilter}
            onClearFilter={handleClearFilter}
          />
        )}
        {openTransfer && <NewTransfer assetIds={selected} open={openTransfer} handleClose={handleTransfer} />}

        {/* Enhanced Import Modal */}
        <Dialog
          maxWidth="sm"
          open={open}
          fullWidth
          TransitionComponent={Grow}
          transitionDuration={300}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
          PaperProps={{
            sx: {
              borderRadius: 3,
              boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
            },
          }}
        >
          <DialogContent sx={{ p: 4 }}>
            <Box sx={{ textAlign: 'center', py: 3 }}>
              <Avatar
                sx={{
                  width: 80,
                  height: 80,
                  mx: 'auto',
                  mb: 2,
                  bgcolor: 'primary.light',
                  color: 'primary.contrastText',
                }}
              >
                <CloudUploadIcon sx={{ fontSize: 40 }} />
              </Avatar>

              <Typography variant="h5" sx={{ mb: 1, fontWeight: 600 }}>
                Upload Assets File
              </Typography>

              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Select a file to import your assets data
              </Typography>

              <Box
                sx={{
                  border: '2px dashed',
                  borderColor: uploadedFile ? 'success.main' : 'divider',
                  borderRadius: 2,
                  p: 4,
                  textAlign: 'center',
                  bgcolor: uploadedFile ? 'success.lighter' : 'background.neutral',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  '&:hover': {
                    borderColor: 'primary.main',
                    bgcolor: 'action.hover',
                  },
                }}
                onClick={() => document.getElementById('assetFile').click()}
              >
                <CloudUploadIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
                <Typography variant="h6" sx={{ mb: 1 }}>
                  {uploadedFile ? uploadedFile.name : 'Click to select file'}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {uploadedFile ? 'File selected successfully' : 'or drag and drop here'}
                </Typography>

                <TextField
                  id="assetFile"
                  name="assetFile"
                  hidden
                  type="file"
                  onChange={(event) => setUploadedFile(event.target.files[0])}
                />
              </Box>

              {uploadedFile && (
                <Box sx={{ mt: 2 }}>
                  <Chip
                    label={`File Size: ${fSize(uploadedFile.size)}`}
                    color="success"
                    variant="outlined"
                    icon={<Iconify icon="eva:file-text-fill" />}
                  />
                </Box>
              )}
            </Box>
          </DialogContent>

          <Divider />

          <DialogActions sx={{ p: 3, gap: 1 }}>
            <Button variant="outlined" onClick={handleClose} sx={{ borderRadius: 2, px: 3 }}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleFileUpload}
              disabled={!uploadedFile}
              sx={{
                borderRadius: 2,
                px: 3,
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                '&:hover': {
                  boxShadow: '0 6px 20px rgba(0,0,0,0.2)',
                },
              }}
            >
              Import Assets
            </Button>
          </DialogActions>
        </Dialog>

        <Container maxWidth="xl" sx={{ py: 3 }}>
          {/* Enhanced Stats Cards */}
          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12} sm={6} md={3}>
              <Grow in timeout={300}>
                <Card
                  sx={{
                    p: 3,
                    textAlign: 'center',
                    borderRadius: 3,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
                    },
                  }}
                >
                  <Avatar
                    sx={{
                      width: 60,
                      height: 60,
                      mx: 'auto',
                      mb: 2,
                      bgcolor: 'rgba(255,255,255,0.2)',
                      backdropFilter: 'blur(10px)',
                    }}
                  >
                    <MonitorIcon sx={{ fontSize: 30 }} />
                  </Avatar>
                  <Typography variant="h3" sx={{ mb: 1, fontWeight: 700 }}>
                    {fNumber(count || 0)}
                  </Typography>
                  <Typography variant="body1" sx={{ opacity: 0.9 }}>
                    Total Assets
                  </Typography>
                </Card>
              </Grow>
            </Grid>

            {/* <Grid item xs={12} sm={6} md={3}>
              <Grow in timeout={400}>
                <Card
                  sx={{
                    p: 3,
                    textAlign: 'center',
                    borderRadius: 3,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                    background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                    color: 'white',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
                    }
                  }}
                >
                  <Avatar
                    sx={{
                      width: 60,
                      height: 60,
                      mx: 'auto',
                      mb: 2,
                      bgcolor: 'rgba(255,255,255,0.2)',
                      backdropFilter: 'blur(10px)',
                    }}
                  >
                    <InventoryIcon sx={{ fontSize: 30 }} />
                  </Avatar>
                  <Typography variant="h3" sx={{ mb: 1, fontWeight: 700 }}>
                    {fNumber(dataFiltered?.length || 0)}
                  </Typography>
                  <Typography variant="body1" sx={{ opacity: 0.9 }}>
                    Active Assets
                  </Typography>
                </Card>
              </Grow>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Grow in timeout={500}>
                <Card
                  sx={{
                    p: 3,
                    textAlign: 'center',
                    borderRadius: 3,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                    background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                    color: 'white',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
                    }
                  }}
                >
                  <Avatar
                    sx={{
                      width: 60,
                      height: 60,
                      mx: 'auto',
                      mb: 2,
                      bgcolor: 'rgba(255,255,255,0.2)',
                      backdropFilter: 'blur(10px)',
                    }}
                  >
                    <TrendingUpIcon sx={{ fontSize: 30 }} />
                  </Avatar>
                  <Typography variant="h3" sx={{ mb: 1, fontWeight: 700 }}>
                    {fNumber(selected?.length || 0)}
                  </Typography>
                  <Typography variant="body1" sx={{ opacity: 0.9 }}>
                    Selected
                  </Typography>
                </Card>
              </Grow>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Grow in timeout={600}>
                <Card
                  sx={{
                    p: 3,
                    textAlign: 'center',
                    borderRadius: 3,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                    background: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
                    color: 'text.primary',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
                    }
                  }}
                >
                  <Avatar
                    sx={{
                      width: 60,
                      height: 60,
                      mx: 'auto',
                      mb: 2,
                      bgcolor: 'primary.main',
                      color: 'white',
                    }}
                  >
                    <FilterListOutlinedIcon sx={{ fontSize: 30 }} />
                  </Avatar>
                  <Typography variant="h3" sx={{ mb: 1, fontWeight: 700 }}>
                    {fNumber(rowsPerPage)}
                  </Typography>
                  <Typography variant="body1" sx={{ opacity: 0.7 }}>
                    Per Page
                  </Typography>
                </Card>
              </Grow>
            </Grid> */}
          </Grid>

          {/* Enhanced Main Content Card */}
          <Card
            sx={{
              borderRadius: 3,
              boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
              overflow: 'hidden',
            }}
          >
            {/* Enhanced Header */}
            <Box
              sx={{
                p: { xs: 2, sm: 3 },
                bgcolor: (theme) =>
                  theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.02)' : 'rgba(0, 0, 0, 0.02)',
                borderBottom: '1px solid',
                borderColor: 'divider',
                backdropFilter: 'blur(10px)',
                position: 'relative',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: '2px',
                  background: (theme) =>
                    theme.palette.mode === 'dark'
                      ? 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent)'
                      : 'linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.05), transparent)',
                },
              }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={2}
                flexWrap="wrap"
                gap={2}
              >
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5, color: 'text.primary' }}>
                    Asset Management
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Manage and track your organization's fixed assets
                  </Typography>
                </Box>

                <Stack direction="row" spacing={2} flexWrap="wrap" gap={1}>
                  {selected?.length > 0 && (
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => setOpeTransfer(true)}
                      startIcon={<SendOutlinedIcon />}
                      sx={{
                        borderRadius: 3,
                        px: 3,
                        py: 1.25,
                        fontWeight: 600,
                        textTransform: 'none',
                        boxShadow: 'none',
                        '&:hover': {
                          boxShadow: (theme) =>
                            theme.palette.mode === 'dark'
                              ? '0 4px 20px rgba(255, 255, 255, 0.05)'
                              : '0 4px 20px rgba(0, 0, 0, 0.08)',
                        },
                      }}
                    >
                      Transfer ({selected.length})
                    </Button>
                  )}

                  <Tooltip title="Sync asset information from ERP">
                    <Button
                      variant="outlined"
                      onClick={() => syncERPData()}
                      startIcon={<SyncOutlinedIcon />}
                      sx={{
                        borderRadius: 3,
                        px: 3,
                        py: 1.25,
                        fontWeight: 600,
                        textTransform: 'none',
                        borderColor: (theme) =>
                          theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)',
                        '&:hover': {
                          borderColor: 'primary.main',
                          bgcolor: (theme) =>
                            theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.04)',
                        },
                      }}
                    >
                      Sync with ERP
                    </Button>
                  </Tooltip>

                  {activeFilters && (
                    <Chip
                      label="Filters active"
                      color="primary"
                      size="small"
                      onDelete={handleClearFilter}
                      sx={{ alignSelf: 'center' }}
                    />
                  )}

                  <Tooltip title="Filter assets by various criteria">
                    <Button
                      variant="outlined"
                      onClick={() => setOpenFilter(true)}
                      startIcon={<FilterListOutlinedIcon />}
                      sx={{
                        borderRadius: 3,
                        px: 3,
                        py: 1.25,
                        fontWeight: 600,
                        textTransform: 'none',
                        borderColor: (theme) =>
                          activeFilters
                            ? 'primary.main'
                            : theme.palette.mode === 'dark'
                            ? 'rgba(255, 255, 255, 0.12)'
                            : 'rgba(0, 0, 0, 0.12)',
                        '&:hover': {
                          borderColor: 'primary.main',
                          bgcolor: (theme) =>
                            theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.04)',
                        },
                      }}
                    >
                      Filter
                    </Button>
                  </Tooltip>

                  {/* {!isManager && (
                    <>
                      <Tooltip title="Import assets from file">
                        <Button
                          variant="outlined"
                          onClick={handleOpen}
                          startIcon={<CloudUploadIcon />}
                          sx={{
                            borderRadius: 3,
                            px: 3,
                            py: 1.25,
                            fontWeight: 600,
                            textTransform: 'none',
                            borderColor: (theme) =>
                              theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)',
                            '&:hover': {
                              borderColor: 'primary.main',
                              bgcolor: (theme) =>
                                theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          Import
                        </Button>
                      </Tooltip>

                      <Button
                        variant="contained"
                        component={RouterLink}
                        to={'/dashboard/assets/new'}
                        startIcon={<Iconify icon="eva:plus-fill" />}
                        sx={{
                          borderRadius: 3,
                          px: 3,
                          py: 1.25,
                          fontWeight: 600,
                          textTransform: 'none',
                          boxShadow: 'none',
                          bgcolor: 'primary.main',
                          '&:hover': {
                            bgcolor: 'primary.dark',
                            boxShadow: (theme) =>
                              theme.palette.mode === 'dark'
                                ? '0 4px 20px rgba(255, 255, 255, 0.05)'
                                : '0 4px 20px rgba(0, 0, 0, 0.08)',
                          },
                        }}
                      >
                        New Asset
                      </Button>
                    </>
                  )} */}
                </Stack>
              </Stack>
            </Box>

            {/* Enhanced Table Content */}
            <CardContent sx={{ p: 0 }}>
              {isLoading && (
                <Box sx={{ width: '100%' }}>
                  <LinearProgress
                    sx={{
                      height: 3,
                      '& .MuiLinearProgress-bar': {
                        background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
                      },
                    }}
                  />
                </Box>
              )}

              {isUploading && (
                <Box sx={{ p: 3, textAlign: 'center' }}>
                  <Fade in>
                    <Stack spacing={2}>
                      <CircularProgress size={40} />
                      <Typography variant="h6" color="primary">
                        Uploading assets...
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Please wait while we process your file
                      </Typography>
                    </Stack>
                  </Fade>
                </Box>
              )}

              <Scrollbar>
                <TableContainer
                  component={Paper}
                  sx={{
                    minWidth: 800,
                    boxShadow: 'none',
                    border: 'none',
                  }}
                >
                  {isLoading ? (
                    <Box sx={{ p: 3 }}>
                      <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
                        {[...Array(5)].map((_, index) => (
                          <Grid item xs={12} key={index}>
                            <TableSkeleton sx={{ height: denseHeight }} />
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  ) : (
                    <Table size="medium">
                      <UserTableHead
                        order={order}
                        orderBy={orderBy}
                        rowCount={fixedAssets?.length}
                        numSelected={selected?.length}
                        onRequestSort={handleSort}
                        onSelectAllClick={handleSelectAllClick}
                        headLabel={[
                          { id: 'asset_tag', label: 'Asset ID', alignRight: false },
                          { id: 'name', label: 'Asset Name', alignRight: false },
                          { id: 'asset_class', label: 'Category', alignRight: false },
                          { id: 'barcode_number', label: 'Barcode', alignRight: false },
                          { id: 'serial_no', label: 'Serial Number', alignRight: false },
                          { id: 'cost', label: 'Cost', alignRight: false },
                          { id: 'location', label: 'Location', alignRight: false },
                          { id: 'department', label: 'Department', alignRight: false },
                          { id: 'assigned_to', label: 'Assigned To', alignRight: false },
                          { id: 'condition', label: 'Status', alignRight: false },
                          { id: '' },
                        ]}
                      />
                      <TableBody>
                        {(dataFiltered?.length > 0 &&
                          dataFiltered?.map(
                            (row, index) =>
                              (row && (
                                <UserTableRow
                                  key={row.id}
                                  asset={row}
                                  selected={selected.indexOf(row.id) !== -1}
                                  handleSelectClick={(event) => handleSelectClick(event, row.id)}
                                />
                              )) || <TableSkeleton key={index} sx={{ height: denseHeight }} />
                          )) || <TableNoData isNotFound={isNotFound} />}
                      </TableBody>
                    </Table>
                  )}
                </TableContainer>
              </Scrollbar>

              {/* Enhanced Pagination */}
              <Box sx={{ p: 2, borderTop: '1px solid', borderColor: 'divider' }}>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 50, 100]}
                  component="div"
                  count={count || 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{
                    '& .MuiTablePagination-select': {
                      borderRadius: 1,
                    },
                    '& .MuiTablePagination-actions button': {
                      borderRadius: 1,
                    },
                  }}
                />
              </Box>
            </CardContent>
          </Card>
        </Container>
      </Page>
    </>
  );
}
